import React from 'react';
import { readableStatus } from '../../../../../../../common/domain/submission';
import { Submission } from '../../submission-graphql';
import { COLORS } from '../../../../../../../common/Styleguide/Common/colors';
import { styled, useTheme } from '@mui/material/styles';
import { StyledButton } from '../../../../../../../common/Styleguide/Common/Button';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { StyledBodyText } from '../../../../../../../common/Styleguide/Common/Text';
import { getGameUrl } from '../../../../../../../common/domain-names';
import { getStatusColor } from '../../../Games/GameList/gamesList.helper';
import { submissionHadBasicLaunch } from '../../../../../../helpers/flowHelpers';

interface SubmissionStatusBadgeProps {
  submission: Submission;
}

const StyledSubmissionStatusBadge = styled('div', {
  shouldForwardProp: (prop) => prop !== 'color',
})<{ color: string }>(({ color }) => ({
  backgroundColor: color,
  width: 'fit-content',
  padding: '5px 10px',
  borderRadius: 6,
  color: COLORS.black[90],
  fontSize: 12,
  textTransform: 'uppercase',
  fontWeight: '700',
  lineHeight: '135%',
}));

const SubmissionStatusBadge: React.FC<SubmissionStatusBadgeProps> = ({ submission }) => {
  const { spacing } = useTheme();

  const slug = submission.slug;
  const gameUrl = getGameUrl(slug, { cacheBust: true });

  // show the link to portal if a submission has not terminated the flow in a negative way (REJECTED or FINALIZED), or has been RELEASED, or has gone through basic launch (could still be in basic launch, or could have moved to full launch)
  const showPortalLink =
    !['REJECTED', 'FINALIZED'].includes(submission.status) &&
    (submission.status === 'RELEASED' || submissionHadBasicLaunch(submission.statusChanges));

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: spacing(1) }}>
      <StyledSubmissionStatusBadge color={getStatusColor(submission.status)}>
        {readableStatus(submission.status)}
      </StyledSubmissionStatusBadge>
      {showPortalLink && (
        <a href={gameUrl} target="_blank" rel="noopener noreferrer">
          <StyledButton sx={{ borderRadius: 0.75, px: 1 }} height={26} variant="outlined" color="darkGrey">
            <StyledBodyText variant="bodyLower2" sx={{ fontWeight: 700 }}>
              VIEW GAME
            </StyledBodyText>
            <OpenInNewIcon style={{ marginRight: 0, marginLeft: spacing(0.75) }} />
          </StyledButton>
        </a>
      )}
    </div>
  );
};

export default SubmissionStatusBadge;
